import React from 'react';

type HtmlViewerProps = {
  as?: string | React.ElementType;
  className?: string;
  content: string;
};
const HtmlViewer = React.memo(
  ({ as: Element = 'div', content, className }: HtmlViewerProps) => {
    return (
      <Element
        className={className}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  }
);

export default HtmlViewer;
